import Glide from '@glidejs/glide';

import { IGetNewsSlidesArray } from './types';
import { NewsPreviewProps } from '../NewsPreview';


export const newsGlider = new Glide('#newsGlide', {
    type: 'slider',
    startAt: 0,
    perSwipe: '|',
    gap: 8,
    perView: 3,
    breakpoints: {
        480: {
            perView: 1,
        },
        1280: {
            perView: 2,
        },
    },
});

export const getNewsSlidesArray = ({
    elements,
    rowCount,
    colCount,
}: IGetNewsSlidesArray): NewsPreviewProps[][] => {
    const slides = [];
    const slidesCount = Math.max(Math.ceil(Math.ceil(
        elements.length / colCount,
    ) / rowCount) * colCount, colCount);

    for (let slideIndex = 0; slideIndex < slidesCount; slideIndex++) {
        const slide = [];
        const currentElementIndex = slideIndex + Math.floor(
            slideIndex / colCount,
        ) * colCount * (rowCount - 1);
        for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
            const pickElementIndex = currentElementIndex + colCount * rowIndex;
            if (pickElementIndex < elements.length)
                slide.push(elements[pickElementIndex]);
        }
        slides.push(slide);
    }
    return slides;
};
